import React from 'react';
import styled from '@emotion/styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

import { Input } from './Input';

const InputSearchStyled = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
`;

const IconWrapper = styled.span`
  position: absolute;
  right: 0;
  cursor: pointer;
  padding: 0.43rem 0.86rem;

  svg {
    max-width: 1.07rem;
    max-height: 1.22rem;
    color: #555;
  }
`;

const InputSearch = ({ onAction, inputProps = {}, ...props }) => {
  return (
    <InputSearchStyled {...props}>
      <Input {...inputProps} />
      <IconWrapper onClick={onAction}>
        <FontAwesomeIcon icon={faSearch} size="lg" />
      </IconWrapper>
    </InputSearchStyled>
  );
};

export { InputSearch };
